import { alertError } from "components/Alert";
import { initFileUploadData } from "constants/fileUploadConstant";
import { subcontractInvoiceApiNm } from "constants/subcontractConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import dayjs from "dayjs";
import { useCallback } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { useState } from "react";
import { addIdForDataGrid } from "utils";
import { initInvFilterData } from "./initData";


let selectedId = 0;
let selectedPVId = 0;
let lastFilter = null

const useSubcontractInvoice = () =>{

  const [dataTable, setDataTable] = useState([]);
  const [dialogExpenseOpen, setDialogExpenseOpen] = useState(false);
  const [dialogPVOpen, setDialogPVOpen] = useState(false);
  const [filterData, setFilterData] = useState(initInvFilterData)
  const [selectionModel, setSelectionModel] = useState([])
  const [fileUploadData, setFileUploadData] = useState(initFileUploadData())

  const {ax, msData} = useContext(GlobalStateContext)

  const onAddButtonClick = useCallback(() =>{
    selectedId = 0
    setDialogExpenseOpen(true)
  }, [])

  const searchScInvoice = useCallback((filterData)=>{
    ax.post(subcontractInvoiceApiNm.getSubcontractInvoiceTable, filterData).then(value=>{
      if(value.data){
        setDataTable(addIdForDataGrid(value.data, "ScInvId"))
        lastFilter = {...filterData}
      }
    })
  }, [ax])
  
  const openExpenseDialog = useCallback((id)=>{
    selectedId = id
    setDialogExpenseOpen(true)
  }, [])

  const openPVDialog = useCallback(()=>{
    if(selectionModel.length === 0){
      alertError("กรุณาเลือกใบแจ้งหนี้ที่ต้องการสร้างใบสำคัญจ่าย")
      return
    }

    const scIds = dataTable.filter(item=>selectionModel.includes(item.ScInvId)).map(item=>item.ScId)
   
    if (new Set(scIds).size !== 1) {
      alertError("กรุณาเลือกใบแจ้งหนี้ที่มี รถร่วม เดียวกัน");
      return;
    }
    for(const row of dataTable){

      if(selectionModel.includes(row.ScInvId) && row.PVNo){
        alertError(`ใบแจ้งหนี้ ${row.ScInvNo} มีใบสำคัญจ่ายแล้วไม่สามารถสร้างใบสำคัญจ่ายได้`)
        return
      }
    }
    selectedPVId = 0
    setDialogPVOpen(true)
  }, [selectionModel, dataTable])

  const onExpenseDailogFinish = useCallback(()=>{
    setDialogExpenseOpen(false)
    searchScInvoice(lastFilter)
  }, [searchScInvoice]) 

  const handleSelectionModelChange = useCallback((newSelectionModel)=>{
    setSelectionModel(newSelectionModel)
  }, [])

  const handlePVNoClick = useCallback((pvId)=>{
    selectedPVId = pvId
    setDialogPVOpen(true)
  }, [])
  useEffect(()=>{
    const startFilter = {
      ...initInvFilterData,
      ScInvDteSt: dayjs(dayjs().format("YYYY-MM-DD 00:00:00.000")),
      ScInvDteEn: dayjs(dayjs().format("YYYY-MM-DD 23:59:59.997"))
    }
    lastFilter = {...startFilter}
    searchScInvoice(startFilter)
    setFilterData(startFilter)
  }, [searchScInvoice])

  return {
    state: {selectedId, selectedPVId, dataTable, dialogExpenseOpen, filterData, msData, selectionModel
      , dialogPVOpen, fileUploadData},
    fn: {onAddButtonClick, setDialogExpenseOpen, setFilterData, searchScInvoice, openExpenseDialog
      , onExpenseDailogFinish, handleSelectionModelChange, setDialogPVOpen, openPVDialog, handlePVNoClick
      , setFileUploadData}
  }
}

export default useSubcontractInvoice